var Processor = require('./processor');

exports.Processor = Processor;



//////////////////
// WEBPACK FOOTER
// ./~/pixelworks/lib/index.js
// module id = 571
// module chunks = 1